module.exports = __webpack_public_path__ + "img/bp_giftbg_0010.aac0c5b2.png";